import { createStyles, rem } from '@mantine/core'

export default createStyles(() => {
  return {
    root: {
      borderRadius: rem(16),
      gap: rem(8),
      backgroundColor: '#fff',
      padding: rem(12),
      boxShadow: '0 4px 16px 0px #0000000A',
      cursor: 'pointer',
    },
    heading: { color: '#EA0029' },
    description: {},
  }
})
